import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  signupData: null,
  loading: true,
  token: null, 
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setSignupData(state, action) {
      state.signupData = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload; // access token stored in Redux temporarily
    },
    clearAuth(state) {
      state.token = null;
      state.signupData = null;
    },
  },
});

export const { setSignupData, setLoading, setToken, clearAuth } = authSlice.actions;

export default authSlice.reducer;
